import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";
import "@/utils/axiosConfig"; // Global axios configuration

// Initialize Sentry error tracking (Req 14.5)
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 0.1,
    environment: process.env.NODE_ENV || "development",
    beforeSend(event) {
      // Filter sensitive data from Sentry events
      if (event.request && event.request.headers) {
        const sensitiveKeys = ["authorization", "cookie", "x-api-key"];
        sensitiveKeys.forEach((key) => {
          if (event.request.headers[key]) {
            event.request.headers[key] = "***";
          }
        });
      }
      return event;
    },
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
